module.exports = __webpack_public_path__ + "img/bitgo.57c4e610.svg";